import React from 'react';

const BlockchainNetwork = ({ className = "w-full h-48" }) => {
  return (
    <svg 
      className={className}
      viewBox="0 0 600 200" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="blockGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1F2937" />
          <stop offset="100%" stopColor="#374151" />
        </linearGradient>
        <filter id="blockGlow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge> 
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Blockchain Blocks */}
      <g className="animate-pulse">
        {/* Block 1 */}
        <rect x="50" y="80" width="60" height="40" rx="5" fill="url(#blockGradient)" stroke="#8B5CF6" strokeWidth="2" filter="url(#blockGlow)" />
        <text x="80" y="105" textAnchor="middle" className="fill-white text-xs font-mono">Block 1</text>
        
        {/* Block 2 */}
        <rect x="150" y="80" width="60" height="40" rx="5" fill="url(#blockGradient)" stroke="#EC4899" strokeWidth="2" filter="url(#blockGlow)" />
        <text x="180" y="105" textAnchor="middle" className="fill-white text-xs font-mono">Block 2</text>
        
        {/* Block 3 */}
        <rect x="250" y="80" width="60" height="40" rx="5" fill="url(#blockGradient)" stroke="#F59E0B" strokeWidth="2" filter="url(#blockGlow)" />
        <text x="280" y="105" textAnchor="middle" className="fill-white text-xs font-mono">Block 3</text>
        
        {/* Block 4 */}
        <rect x="350" y="80" width="60" height="40" rx="5" fill="url(#blockGradient)" stroke="#10B981" strokeWidth="2" filter="url(#blockGlow)" />
        <text x="380" y="105" textAnchor="middle" className="fill-white text-xs font-mono">Block 4</text>
        
        {/* Block 5 */}
        <rect x="450" y="80" width="60" height="40" rx="5" fill="url(#blockGradient)" stroke="#EF4444" strokeWidth="2" filter="url(#blockGlow)" />
        <text x="480" y="105" textAnchor="middle" className="fill-white text-xs font-mono">Block 5</text>
      </g>
      
      {/* Connection Lines */}
      <path d="M110 100 L 150 100" stroke="#8B5CF6" strokeWidth="3" className="animate-pulse" />
      <path d="M210 100 L 250 100" stroke="#EC4899" strokeWidth="3" className="animate-pulse" style={{animationDelay: '0.2s'}} />
      <path d="M310 100 L 350 100" stroke="#F59E0B" strokeWidth="3" className="animate-pulse" style={{animationDelay: '0.4s'}} />
      <path d="M410 100 L 450 100" stroke="#10B981" strokeWidth="3" className="animate-pulse" style={{animationDelay: '0.6s'}} />
      
      {/* Data Flow Particles */}
      <circle cx="130" cy="100" r="3" fill="#8B5CF6" className="animate-ping" />
      <circle cx="230" cy="100" r="3" fill="#EC4899" className="animate-ping" style={{animationDelay: '0.3s'}} />
      <circle cx="330" cy="100" r="3" fill="#F59E0B" className="animate-ping" style={{animationDelay: '0.6s'}} />
      <circle cx="430" cy="100" r="3" fill="#10B981" className="animate-ping" style={{animationDelay: '0.9s'}} />
      
      {/* Network Nodes */}
      <circle cx="80" cy="50" r="8" fill="#8B5CF6" className="animate-bounce" />
      <circle cx="180" cy="30" r="6" fill="#EC4899" className="animate-bounce" style={{animationDelay: '0.2s'}} />
      <circle cx="280" cy="45" r="7" fill="#F59E0B" className="animate-bounce" style={{animationDelay: '0.4s'}} />
      <circle cx="380" cy="35" r="6" fill="#10B981" className="animate-bounce" style={{animationDelay: '0.6s'}} />
      <circle cx="480" cy="50" r="8" fill="#EF4444" className="animate-bounce" style={{animationDelay: '0.8s'}} />
      
      {/* Network Connections */}
      <path d="M80 50 Q 130 40 180 30" stroke="#8B5CF6" strokeWidth="2" fill="none" opacity="0.6" className="animate-pulse" />
      <path d="M180 30 Q 230 35 280 45" stroke="#EC4899" strokeWidth="2" fill="none" opacity="0.6" className="animate-pulse" style={{animationDelay: '0.2s'}} />
      <path d="M280 45 Q 330 40 380 35" stroke="#F59E0B" strokeWidth="2" fill="none" opacity="0.6" className="animate-pulse" style={{animationDelay: '0.4s'}} />
      <path d="M380 35 Q 430 40 480 50" stroke="#10B981" strokeWidth="2" fill="none" opacity="0.6" className="animate-pulse" style={{animationDelay: '0.6s'}} />
    </svg>
  );
};

export default BlockchainNetwork;
